import { render, staticRenderFns } from "./pdf-preview.vue?vue&type=template&id=07b4d763"
import script from "./pdf-preview.vue?vue&type=script&lang=js"
export * from "./pdf-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports